




















































import {Component, Ref} from 'vue-property-decorator'
import productModule from '@/store/module/ProductModule';
import ThingModelApi from "@/module/thing/ThingModelApi";
import {Container} from "typescript-ioc";
import {Event, Property, Resource, ResourceType, Service} from "@/model/ThingModel";
import {
  EventCreateForm,
  EventEditForm,
  PropertyEditForm,
  ResourcesUpsertForm,
  ResourceUpsertForm,
  ServiceEditForm
} from "@/form/TmodelForm";
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";

import EditDialog from "@/component/Crud/edit-dialog.vue";
import PropertyUpsertFormItems from "@/view/device-manage/product/property-upsert-form-items.vue";
import EventUpsertFormItems from "@/view/device-manage/product/event-upsert-form-items.vue";
import ServiceUpsertFormItems from "@/view/device-manage/product/service-upsert-form-items.vue";
import thingModelModule from "@/store/module/ThingModelModule";
import _ from 'lodash';
import {Form} from "element-ui";
import {funRules} from "@/view/device-manage/product/fun-rules";

@Component({
  components: {
    DataSpecsFormItems,
    EditDialog,
    PropertyUpsertFormItems,
    EventUpsertFormItems,
    ServiceUpsertFormItems,
  },
})
export default class FunEditDialog extends EditDialog {

  private thingModelApi = Container.get(ThingModelApi)

  @Ref()
  private editDialog!: EditDialog

  @Ref()
  private editElForm!: Form

  private get rules() {
    return funRules(this.editForm.resourceType)
  }

  private lodash = _

  private propEditForm =
      this.initPropertyEditForm()

  private eventEditForm =
      this.initEventEditForm()

  private serviceEditForm =
      this.initServiceEditForm()

  private editForm: ResourceUpsertForm<Resource> =
      this.propEditForm

  initForms() {
    this.propEditForm =
        this.initPropertyEditForm()
    this.eventEditForm =
        this.initEventEditForm()
    this.serviceEditForm =
        this.initServiceEditForm()
  }

  async open() {
    await this.editDialog.open()
  }

  private beforeOpenEditDialog() {
    this.editElForm?.resetFields()
    this.initForms()
    this.changeEditForm(this.getActiveResource().resourceType)
  }

  private async editFun() {
    const valid = await this.editElForm.validate()
    if (!valid) return

    const editForm = this.getEditForm()
    const form = new ResourcesUpsertForm(productModule.active.id)
    switch (editForm.resourceType) {
      case ResourceType.PROPERTY:
        form.properties.push((editForm as PropertyEditForm).toResource())
        break
      case ResourceType.EVENT:
        form.events.push((editForm as EventCreateForm).toResource())
        break
      case ResourceType.SERVICE:
        form.services.push((editForm as ServiceEditForm).toResource())
        break
    }
    await this.thingModelApi.resourcesUpsert(form)
  }

  private getEditForm() {
    return this.editForm
  }

  private getActiveResource(): Resource {
    return _.cloneDeep(thingModelModule.resourceOrNull)
        ?? new class extends Resource {
        }
  }

  private changeEditForm(resourceType: ResourceType) {
    switch (resourceType) {
      case ResourceType.PROPERTY:
        this.editForm = this.propEditForm
        break
      case ResourceType.EVENT:
        this.editForm = this.eventEditForm
        break
      case ResourceType.SERVICE:
        this.editForm = this.serviceEditForm
        break
    }
  }

  private initPropertyEditForm(): PropertyEditForm {
    if (this.getActiveResource()?.resourceType != ResourceType.PROPERTY)
      return new PropertyEditForm()

    return new PropertyEditForm(this.getActiveResource() as Property)
  }

  private initEventEditForm(): EventEditForm {
    if (this.getActiveResource()?.resourceType != ResourceType.EVENT)
      return new EventEditForm()

    return new EventEditForm(this.getActiveResource() as Event)
  }

  private initServiceEditForm(): ServiceEditForm {
    if (this.getActiveResource().resourceType != ResourceType.SERVICE)
      return new ServiceEditForm()

    return new ServiceEditForm(this.getActiveResource() as Service)
  }

  isProperty() {
    return this.getActiveResource().resourceType == ResourceType.PROPERTY
  }

  isEvent() {
    return this.getActiveResource().resourceType == ResourceType.EVENT
  }

  isService() {
    return this.getActiveResource().resourceType == ResourceType.SERVICE
  }
}
